import React, {useEffect} from 'react';

import { Box, Stack, Typography } from '@mui/material';
import TurnLeftIcon from '@mui/icons-material/TurnLeft';
import TurnRightIcon from '@mui/icons-material/TurnRight';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import { useTranslation } from 'react-i18next';

import { setIconManeuver } from '../utils/directionConverter';
import { ObstaclesWarningContainer } from './ObstaclesWarningContainer';

const styleLabel = {
  fontSize: '1em', 
  color: '#000000',
  textWrap: 'pre-line'
};

const generateDirectionFromType = (type, instruction, nextInstruction) => {
  return (
    <Stack sx={{alignItems: 'center'}} direction="row" spacing={1}>
      {setIconManeuver(type)}
      <Stack spacing={1}>
        <Typography sx={styleLabel}>
          {instruction}
        </Typography>
        <Typography sx={styleLabel}>
          {nextInstruction}
        </Typography>
      </Stack>
    </Stack>
  );
};

const generateDirectionFromAngle = (angle, name) => {
  const {t} = useTranslation();
  if (angle > 70 && angle < 110) {
    return (
      <>
        <Stack sx={{alignItems: 'center'}} direction="row" spacing={1}>
          <TurnLeftIcon />
          <Typography sx={styleLabel}>
            {t('stepPath.turn-left')} {name}
          </Typography>
        </Stack>
      </>
    );
  } else if (angle > 250 && angle < 290) {
    return (
      <>
        <Stack sx={{alignItems: 'center'}} direction="row" spacing={1}>
          <TurnRightIcon />
          <Typography sx={styleLabel}>
            {t('stepPath.turn-right')} {name}
          </Typography>
        </Stack>
      </>
    );
  } else {
    return (
      <>
        <Stack sx={{alignItems: 'center'}} direction="row" spacing={1}>
          <ArrowUpwardIcon />
          <Typography sx={styleLabel}>
            {t('stepPath.forward')} {name}
          </Typography>
        </Stack>
      </>
    );
  }
};


export const RoutingInformation = ({ ta, type, instruction, nextInstruction, name, obstacles }) => {

  const {t} = useTranslation();

  useEffect(() => {
  }, []);

  return (
    <Box sx={{alignItems: 'center'}}>
      {type ? generateDirectionFromType(type, instruction, nextInstruction) : generateDirectionFromAngle(ta, name) }
      {obstacles && (
        <ObstaclesWarningContainer label={t('obstacles.obstacles_alerts_step')} styleLabel={styleLabel} />
      )}
    </Box>
  );
}; 